var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4151 9.58475C11.6643 8.83422 10.6461 8.4126 9.58445 8.4126C8.52281 8.4126 7.50463 8.83422 6.75379 9.58475L3.9222 12.4154C3.17134 13.1663 2.74951 14.1847 2.74951 15.2465C2.74951 16.3084 3.17134 17.3268 3.9222 18.0777C4.67306 18.8285 5.69145 19.2504 6.75333 19.2504C7.8152 19.2504 8.83359 18.8285 9.58445 18.0777L10.9998 16.6623",
    stroke: "#71903E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58447 12.4154C10.3353 13.1659 11.3535 13.5875 12.4151 13.5875C13.4768 13.5875 14.495 13.1659 15.2458 12.4154L18.0774 9.5847C18.8283 8.83384 19.2501 7.81545 19.2501 6.75357C19.2501 5.69169 18.8283 4.67331 18.0774 3.92245C17.3265 3.17158 16.3081 2.74976 15.2463 2.74976C14.1844 2.74976 13.166 3.17158 12.4151 3.92245L10.9998 5.33778",
    stroke: "#71903E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkChain);
export default __webpack_public_path__ + "static/media/link-chain.5eaf563ef6e8f15e4c21926e31fa6e99.svg";
export { ForwardRef as ReactComponent };